export default __webpack_public_path__ + "static/media/0025.1fb19e11.jpg";